import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";

const QuizErrorModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      center
      open={props?.open}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseIcon={false}
      classNames={{ modal: "success-modal", root: "modal-own-wrapper" }}
    >
      <div className="settings-wrapper mx-auto">
        <div className="stripe border-bottom heading-wrapper">
          <p className="h4 font-weight-bold text-center terms-head">
            {t("user.quizError.unsuccessfulAttempt")}
          </p>
        </div>
        <div className="mx-lg-3 text-justify p-3 terms-text">
          <p className="font-weight-normal" dangerouslySetInnerHTML={{__html: props?.text}}>
          </p>
        </div>
        <div className="stripe pt-3 border-top">
          <div className="col-md-12 text-center">
            <button
              className="btnFooter footer-width py-2 px-2"
              onClick={() => props?.closeModal()}
            >
              {t("user.quizError.continueButton")} <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuizErrorModal;
